import React from "react";
import { Handle, Position } from "@xyflow/react";
import { Icon, Text } from "~/components-shared";
import styled from "styled-components";
const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: linear-gradient(135deg, hsl(262 83% 58%), hsl(292 84% 61%));
  color: #ffffff;
  border-radius: 20px;
  width: ${_ref => {
  let {
    $width
  } = _ref;
  return $width;
}}px;
  height: ${_ref2 => {
  let {
    $height
  } = _ref2;
  return $height;
}}px;
  padding: 1em;
`;
const EntityNode = _ref3 => {
  let {
    data,
    selected
  } = _ref3;
  const size = 70 + data.intensity * 5;
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: `${selected ? "border-source-end shadow-lg shadow-source-end/50 scale-110" : "border-source-start/30"}`,
    $width: size,
    $height: size
  }, /*#__PURE__*/React.createElement(Icon, {
    src: "sell",
    scale: 7,
    s: {
      mb: 1
    }
  }), /*#__PURE__*/React.createElement(Text, {
    fontSize: 3,
    weight: "semiBold",
    align: "center"
  }, data.label), /*#__PURE__*/React.createElement(Handle, {
    type: "target",
    position: Position.Left,
    className: "!bg-entity-end !border-2 !border-entity-start !w-3 !h-3"
  }), /*#__PURE__*/React.createElement(Handle, {
    type: "source",
    position: Position.Right,
    className: "!bg-entity-end !border-2 !border-entity-start !w-3 !h-3"
  }));
};
export default EntityNode;